// extracted by mini-css-extract-plugin
export default {"background":"RadialProgress_background__4Qcmk","progress":"RadialProgress_progress__owLX0"};